import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import styles from './PartnerClinic.module.scss';
import { isMobile } from 'react-device-detect';
import hos1 from '../../assets/hos1.jpeg';
import hos2 from '../../assets/hos2.png';
import hos3 from '../../assets/hos3.jpeg';
import partnerClinics from '../../assets/data/partnerClinics.json';

const clinicImages: { [key: string]: string } = { hos1, hos2, hos3 };

function PartnerClinic() {
  return (
    <>
      <Header />
      <div className={styles.categorySelectWrap}>
        <h3>협력의원 정보</h3>
        <ul
          className={`${styles.clinicListWrap} ${
            isMobile ? styles.isMobile : ''
          }`}
        >
          {partnerClinics.map((clinic) => (
            <li key={clinic.name}>
              <div className={styles.hospitalLeft}>
                <img src={clinicImages[clinic.image]} alt={clinic.name} />
                <div className={styles.hospitalInfo}>
                  <p>{clinic.name}</p>
                  <div className={styles.hospitalTag}>
                    {clinic.tags.map((tag) => (
                      <span key={tag}>{tag}</span>
                    ))}
                  </div>
                  {clinic.address && (
                    <p className={styles.hospitalAddress}>{clinic.address}</p>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <Footer />
    </>
  );
}
export default PartnerClinic;
